module.exports = __webpack_public_path__ + "static/media/Icons-30.7928966f.png";